import React, { memo } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import './employeeCardDetail.scss';
import { GroupChatBots } from '../../../../component';
import { SearchIcon, BellIcon, ShareSquareIcon, ClockIcon } from '~svg';

const EmployeeCardDetail = ({ language: { direction = 'ltr' } }) => {
  const MainEmployeeCardDetail = ({
    header,
    chatBot,
    work,
    reminding,
    participate,
  }) => {
    return (
      <section className="employee-card-detail">
        {header}
        <div className="pb-4 pt-1">{chatBot}</div>
        <div className="employee-body pt-1">
          {work}
          {reminding}
          {participate}
        </div>
      </section>
    );
  };

  const RenderAllWorkCard = () => {
    return (
      <div className="work-card-container d-flex justify-content-between">
        <div
          className={`scroll-work-card d-flex justify-content-between scroll-card-${direction}`}
        >
          <WorkCard />

          <WorkCard />

          <WorkCard />
        </div>
      </div>
    );
  };
  const Work = ({ header, card }) => {
    return (
      <div className="work-container pb-4">
        {header}
        {card}
      </div>
    );
  };
  const WorkCard = () => {
    return (
      <div className="work-card mx-1 py-3 bg-white text-third">
        <div className="work-comment text-start px-3">
          <FormattedMessage id="profile.prepareDetiledBrief" />
        </div>
        <div className="work-detail-container d-flex justify-content-between pt-4 px-3">
          <div className="d-flex align-items-center">
            <RenderItem
              icon={<BellIcon size={14} color="white" />}
              text="Oct, 23"
            />
            <RenderItem
              icon={<BellIcon size={14} color="white" />}
              text="4"
              customClass="mx-2"
            />
            <RenderItem icon={<BellIcon size={14} color="white" />} text="3" />
          </div>
          <figure className="m-0 picture">
            <img
              src={require(`../../../../content/images/profilePhoto/person-white-skin.jpg`)}
              alt="person-white-skin"
            />
          </figure>
        </div>
      </div>
    );
  };
  const RenderItem = ({ icon, text, customClass = '' }) => {
    return (
      <span className={` work-detil font-small  p-1 ${customClass}`}>
        {icon}
        <span className="px-1">{text}</span>
      </span>
    );
  };

  const CustomHeader = ({ name, isNew, headerClass = '' }) => {
    return (
      <div
        className={`work-header d-flex justify-content-between pb-1 text-white font-xl-small font-lg-msmall font-smaller ${headerClass} `}
      >
        <FormattedMessage id={`profile.${name}`} />
        {isNew && (
          <span className="">
            <FormattedMessage id="profile.addNew" />
          </span>
        )}
      </div>
    );
  };

  const Participate = ({ header, card }) => {
    return (
      <div className="participate-container">
        {header}
        {card}
      </div>
    );
  };
  const Header = () => {
    return (
      <div className="header-card-detail pb-4 ">
        <RenderIcon icon={<SearchIcon size={16} color="#aaacaf" />} />
        <RenderIcon icon={<BellIcon size={16} color="#aaacaf" />} />
      </div>
    );
  };
  const RenderIcon = ({ icon }) => (
    <span className="header-icon-container bg-white text-third px-3 py-2">
      {icon}
    </span>
  );

  const RemindingEmployee = ({ header, card }) => (
    <div className="reminding-container ">
      {/* {header}
      {card} */}
    </div>
  );
  const RenderAllRemindingCard = () => (
    <div className="all-reminding-card">
      <RemindingCard
        content="prepareAEKTemplateForTheClient"
        date="13:00"
        progressPercentage="80%"
        iconColor=""
      />
      <RemindingCard
        progressPercentage="20%"
        content="prepareForACallWithAClient"
        date="17:30"
        iconColor=""
      />
      <RemindingCard
        content="chooseAnArtist"
        date="OK"
        progressPercentage="100%"
        iconColor=""
      />
    </div>
  );
  const RenderAllParticipateCard = () => {
    return (
      <div className="participate-all-card">
        <ParticipateCard />
        <ParticipateCard />
        <ParticipateCard />
      </div>
    );
  };
  const ParticipateCard = () => {
    return (
      <div className="participate-card d-flex justify-content-between py-3">
        <div className="d-flex align-items-center">
          <span className="bg-warning text-dark rounded-lg px-2">S</span>
          <span className="px-1 text-start font-smaller">
            <FormattedMessage id="profile.sportsInteractive" />
          </span>
          <span className="d-flex align-items-center justify-content-center px-1">
            <ShareSquareIcon
              size={18}
              color="#126eab"
              variant="svg-xsmall svg-md-msmall"
            />
          </span>
        </div>
        <div className="tag-participate px-1 tag-card d-flex align-items-center justify-content-center">
          <ClockIcon
            size={14}
            color="#ecaa0e"
            variant="svg-tiny svg-md-xsmall"
          />
          <span className="px-1 text-start">
            <FormattedMessage id="profile.team" />
          </span>
        </div>
      </div>
    );
  };
  const RemindingCard = ({ content, date, progressPercentage }) => (
    <div className="progress mt-3 bg-secondary-light ">
      <div
        className="progress-bar bg-secondary"
        role="progressbar"
        style={{ width: progressPercentage }}
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div className="progress-content px-3 ">
          <div>
            <BellIcon size={16} color="" variant="" />
            <span className="px-2">
              <FormattedMessage id={`profile.${content}`} />
            </span>
          </div>
          <span>{date}</span>
        </div>
      </div>
    </div>
  );

  return (
    <MainEmployeeCardDetail
      header={<Header />}
      chatBot={<GroupChatBots direction={direction} />}
      work={
        <Work
          header={
            <CustomHeader name={'inWork'} isNew={true} headerClass="px-2" />
          }
          card={<RenderAllWorkCard />}
        />
      }
      reminding={
        <RemindingEmployee
          header={<CustomHeader name={'reminding'} isNew={true} />}
          card={<RenderAllRemindingCard />}
        />
      }
      participate={
        <Participate
          header={<CustomHeader isNew={false} name={'participate'} />}
          card={<RenderAllParticipateCard />}
        />
      }
    />
  );
};
function mapStateToProps(state) {
  return {
    language: state.language,
  };
}
EmployeeCardDetail.propTypes = {
  language: PropTypes.object,
};
EmployeeCardDetail.defaultProps = {
  language: {},
};
export default connect(mapStateToProps)(memo(EmployeeCardDetail));
